import React from "react";

export default function LoginErrorMessage({ message }) {
  if (!message) return null;

  return (
    <div style={{
      background: "#ffe7e7",
      border: "1px solid #ffb3b3",
      color: "#b42e2e",
      borderRadius: 10,
      padding: "12px 14px",
      marginBottom: 12,
      fontSize: 14,
      lineHeight: 1.5,
    }}>
      {message}
    </div>
  );
}
